import { createContext, useContext } from 'react';
import { Alert, Badge, Button, Group } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { Link, Outlet, type RouteObject } from 'react-router-dom';
import { AppChrome, AppSurface } from '@easy-ui';
import { getCapabilities } from './socialClient';
import type { SocialCapabilities } from './socialTypes';
import { PublicationList } from './PublicationList';
import { PublicationEditor } from './PublicationEditor';
import { SocialAccounts } from './SocialAccounts';
import './socialPublications.css';
const CapabilityContext = createContext<SocialCapabilities>({ enabled: false, mode: 'disabled', paused: true });
export const useSocialCapabilities = () => useContext(CapabilityContext);
function SocialLayout() {
  const capabilities = useQuery({ queryKey: ['social-capabilities'], queryFn: getCapabilities, retry: false });
  const value = capabilities.data;
  return <AppChrome className="social-app" topBarStart={<h1>Réseaux sociaux</h1>} topBarEnd={value?.enabled ?
    <Badge color="easyBlue">{value.mode === 'fake' ? 'Simulation' : 'Démonstration'}</Badge> : undefined}>
    <AppSurface>
      {capabilities.isLoading ? <p>Chargement…</p> : !value?.enabled ? <Alert title="Module indisponible">
        {capabilities.error?.message || 'Les publications sociales ne sont pas activées pour cet espace.'}</Alert> :
        <CapabilityContext.Provider value={value}>
          <Group className="social-tabs" gap="lg"><Button component={Link} to="/social" variant="subtle">Publications</Button>
            <Button component={Link} to="/social/accounts" variant="subtle">Comptes connectés</Button></Group>
          {value.mode === 'fake' && <p className="social-notice">Simulation · aucun contenu n’est envoyé à Facebook ou Instagram.</p>}
          {value.paused && <Alert color="yellow" mb="md" title="Envois en pause">Les brouillons restent modifiables. Aucun nouvel envoi ne démarre.</Alert>}
          <Outlet />
        </CapabilityContext.Provider>}
    </AppSurface>
  </AppChrome>;
}
export function createHostedSocialPublicationRoutes(): RouteObject[] {
  return [{ path: '/social', element: <SocialLayout />, children: [
    { index: true, element: <PublicationList /> }, { path: 'new', element: <PublicationEditor /> },
    { path: 'accounts', element: <SocialAccounts /> }, { path: ':publicationId', element: <PublicationEditor /> },
  ] }];
}
